// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__t5IHw","author":"Table_author__2bsj6","authorImage":"Table_authorImage__3NB6k","unreadRow":"Table_unreadRow__2vv0u"};